import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class VideoSyncService {
  private players: HTMLVideoElement[] = [];
  private isSyncing = false;
  private wasPlayingBeforeSeek = false;

  registerPlayer(player: HTMLVideoElement) {
    if (!this.players.includes(player)) {
      this.players.push(player);
      this.setupListeners(player);
    }
    return player;
  }

  unregisterPlayer(player: HTMLVideoElement) {
    const index = this.players.indexOf(player);
    if (index > -1) {
      this.removeListeners(player);
      this.players.splice(index, 1);
    }
  }

  private setupListeners(player: HTMLVideoElement) {
    player.addEventListener("play", this.handlePlay);
    player.addEventListener("pause", this.handlePause);
    player.addEventListener("seeking", this.handleSeeking);
    player.addEventListener("seeked", this.handleSeeked);
  }

  private removeListeners(player: HTMLVideoElement) {
    player.removeEventListener("play", this.handlePlay);
    player.removeEventListener("pause", this.handlePause);
    player.removeEventListener("seeking", this.handleSeeking);
    player.removeEventListener("seeked", this.handleSeeked);
  }

  private handlePlay = (event: Event) => {
    if (this.isSyncing) return;
    this.syncPlayers(event.target as HTMLVideoElement, true);
  };
  private handlePause = (event: Event) => {
    if (this.isSyncing) return;
    if (!this.wasPlayingBeforeSeek) {
      this.syncPlayers(event.target as HTMLVideoElement, false);
    }
  };

  private handleSeeking = (event: Event) => {
    const source = event.target as HTMLVideoElement;
    this.wasPlayingBeforeSeek = !source.paused;
  };

  private handleSeeked = (event: Event) => {
    const source = event.target as HTMLVideoElement;
    this.isSyncing = true;
    this.syncCurrentTime(source);
    if (this.wasPlayingBeforeSeek) {
      this.syncPlayers(source, true);
    }
    this.isSyncing = false;
    this.wasPlayingBeforeSeek = false;
  };

  private syncPlayers(source: HTMLVideoElement, shouldPlay: boolean) {
    this.isSyncing = true;
    for (const player of this.players) {
      if (player !== source) {
        try {
          shouldPlay ? player.play().catch(e => console.error(e)) : player.pause();
        } catch (e) {
          console.error("Error syncing video player:", e);
        }
      }
    }
    this.isSyncing = false;
  }

  private syncCurrentTime(source: HTMLVideoElement) {
    const time = source.currentTime;
    for (const player of this.players) {
      if (player !== source && Math.abs(player.currentTime - time) > 0.1) {
        player.currentTime = time;
      }
    }
  }
}